import Badge from '../components/ui/Badge';

export const getBadge = (data, getLabel) => {
	if (data.required) {
		return <Badge>{getLabel('package_required')}</Badge>;
	} else if (data.included) {
		return <Badge>{getLabel('package_included')}</Badge>;
	} else if (data.recommended) {
		return <Badge>{getLabel('package_recommended')}</Badge>;
	} else {
		return null;
	}
};
